// extracted by mini-css-extract-plugin
module.exports = {"container":"TempModal_container__2ZibR"};